import { Box, Divider, MenuItem, Typography } from "@mui/material";
import LogoutButton from "../../../../authentication/ui/LogoutButton";
import { useObservable } from "../../../../common/ui/ObservableHook";
import { authenticationStateHandler } from "../../../../authentication/logic/AuthenticationStateHandler";
import { AccountPopoverStyles, MenuListStyles } from "../../Layout.styles";
import { useNavigate } from "react-router-dom";
import { useLocale } from "../../../../hooks/UseLocale";
import { useTranslation } from "react-i18next";

interface Props {
  anchorEl: any;
  onClose: () => void;
  open: boolean;
}

export function AccountPopover(props: Props) {
  const profile = useObservable(authenticationStateHandler.profileObservable);
  const { anchorEl, onClose, open } = props;
  const navigate = useNavigate();
  const locale = useLocale();
  const { t } = useTranslation();

  const handleProfileClick = () => {
    navigate(`/${locale}/profile/`);
    onClose();
  };

  return (
    <AccountPopoverStyles
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={onClose}
      open={open}
    >
      <Box>
        <Typography variant="overline">Account</Typography>
        <Typography color="text.secondary" variant="body2">
          {profile?.firstName} {profile?.lastName}
        </Typography>
      </Box>
      <Divider />
      <MenuListStyles disablePadding dense>
        <MenuItem onClick={handleProfileClick}>
          {t("profilePage.profile")}
        </MenuItem>
        <LogoutButton />
      </MenuListStyles>
    </AccountPopoverStyles>
  );
}
